/*
 * Purpose: Factory helpers for Mission anchor blocks (START, GOAL)
 * Last modified: 2026-06-27 | Agent
 * Completeness: 100
 */
import type { Node } from '@/stores/workflowStore';

const genId = () => Math.random().toString(36).slice(2, 11);

export function createMissionStartNode(x = 80, y = 80): Node {
  return {
    id: genId(),
    type: 'start',
    subtype: 'mission',
    config: { name: 'Start' },
    x,
    y,
  };
}

export function createMissionGoalNode(outcome: string, x = 80, y = 180): Node {
  return {
    id: genId(),
    type: 'goal',
    subtype: 'outcome',
    config: {
      outcome: outcome.trim(),
      name: 'Identified outcome',
    },
    x,
    y,
  };
}
